import { RealtimeEventTypes, RfqChangedPayload } from '@interfaces/realtime/events';
import { RealtimeService } from '@services/realtime/realtime.service';
import {
  Observable,
  auditTime,
  distinctUntilChanged,
  filter,
  interval,
  map,
  merge,
  switchMap,
} from 'rxjs';

/** Polling das telas de RFQ com o tempo real de pé: só rede de segurança (card 3588). */
export const RFQ_POLL_CONNECTED_MS = 60_000;
/** Junta rajadas de `rfq.changed` (e-mail chegou + IA terminou em seguida) numa leitura só. */
export const RFQ_REALTIME_AUDIT_MS = 300;

/**
 * Emite quando a tela de RFQ deve reler pelo REST por causa do tempo real (card 3588): a cada
 * `rfq.changed` que passa no filtro e quando a conexão volta depois de cair (eventos do intervalo
 * se perderam). O evento é só a dica; a lista e os detalhes vêm sempre do GET.
 */
export function rfqChanged$(
  realtime: RealtimeService,
  matches: (payload: RfqChangedPayload) => boolean = () => true
): Observable<void> {
  const events$ = realtime
    .on(RealtimeEventTypes.RfqChanged)
    .pipe(filter(envelope => envelope.topic.startsWith('company:') && matches(envelope.payload)));

  return merge(events$, realtime.reconnected$).pipe(
    auditTime(RFQ_REALTIME_AUDIT_MS),
    map(() => undefined)
  );
}

/**
 * Polling de reserva das telas de RFQ: de `RFQ_POLL_CONNECTED_MS` com o tempo real conectado e de
 * `offlinePollMs` fora disso (o intervalo de antes do card 3588). Quem assina decide quando ele
 * vale (ex.: só com RFQ aguardando resposta).
 */
export function rfqFallbackPoll$(
  realtime: RealtimeService,
  offlinePollMs: number
): Observable<void> {
  return realtime.status$.pipe(
    map(status => (status === 'connected' ? RFQ_POLL_CONNECTED_MS : offlinePollMs)),
    distinctUntilChanged(),
    switchMap(periodMs => interval(periodMs)),
    map(() => undefined)
  );
}
